import { render, staticRenderFns } from "./EmergencyCta.vue?vue&type=template&id=e6b70472"
import script from "./EmergencyCta.vue?vue&type=script&lang=js"
export * from "./EmergencyCta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports